import { Form, Input } from "antd";

const { TextArea } = Input;

const TextAreaField = ({ field }) => (
  <Form.Item
    hidden={field?.hidden}
    key={field.name}
    name={field.name}
    label={field.label}
    rules={field.rules}
    extra={field.extra}
  >
    <TextArea
      placeholder={field.placeholder}
      disabled={field.disabled}
      maxLength={field.maxLength}
      showCount={field.showCount}
    />
  </Form.Item>
);

export default TextAreaField;
